// ชื่อ action ในหัว dialog ยืนยัน (ActionConfirmDialog) — แยกตามหน้า (ดู constants/modes.js)
export const APPROVAL_ACTION_LABEL = {
  APPROVE: 'อนุมัติ',
  REJECT: 'ปฏิเสธ',
  HOLD: 'รอก่อน',
  RESET: 'ยกเลิก',
};

export const REVIEW_ACTION_LABEL = {
  REVIEW: 'ตรวจสอบแล้ว',
  FLAG: 'พบปัญหา',
  HOLD: 'รอก่อน',
  RESET: 'ยกเลิก',
};

// label นำหน้าชื่อผู้ทำรายการในคอลัมน์ "อนุมัติโดย / เวลา" — เปลี่ยนคำตาม payment_approval_status จริง
// ของแถวนั้น (ไม่ใช่ label เดียวคงที่) เพราะ "อนุมัติโดย" ไม่ควรโผล่ตอนแถวถูกปฏิเสธ/hold ไว้
export const APPROVAL_ACTOR_LABEL = {
  APPROVED: 'อนุมัติโดย',
  REJECTED: 'ปฏิเสธโดย',
  HOLD: 'Hold ไว้โดย',
};

// label นำหน้าชื่อผู้ทำรายการในคอลัมน์ "ตรวจสอบโดย / เวลา" — เปลี่ยนคำตาม review_status จริงของแถวนั้น
export const REVIEW_ACTOR_LABEL = {
  REVIEWED: 'ตรวจสอบโดย',
  FLAGGED: 'ระบุปัญหาโดย',
  HOLD: 'พักไว้โดย',
};

// สถานะอนุมัติจ่ายเงิน (Expenses.payment_approval_status) — แท็บ วันนี้/ค้าง/อนาคต/รอก่อน กรองแค่
// PENDING/HOLD (APPROVED/REJECTED หายจากคิวทันทีที่กด) ส่วนแท็บ "ประวัติ" กรอง APPROVED/REJECTED
// โดยเฉพาะ เลยต้องมี meta ครบทั้ง 4 ค่าไว้ให้ badge โชว์ถูกต้องไม่ว่าจะอยู่แท็บไหน
export const PAYMENT_APPROVAL_STATUS_META = {
  PENDING: { label: 'รออนุมัติให้จ่าย', color: 'default' },
  HOLD: { label: 'พักการจ่าย', color: 'warning' },
  APPROVED: { label: 'ให้จ่าย', color: 'success' },
  REJECTED: { label: 'ไม่ให้จ่าย', color: 'error' },
};

// สีพื้นหลังแถวจางๆ ให้ตรงกับสีของ chip สถานะอนุมัติจ่ายเงิน (PAYMENT_APPROVAL_STATUS_META.color ข้างบน) —
// โทนอ่อนมาก (alpha ~0.08) กันไม่ให้กลืนตัวหนังสือ/แย่งความสนใจจาก chip เอง แค่ช่วยให้กวาดตาแยกสถานะได้เร็ว
export const STATUS_ROW_TINT = {
  default: 'rgba(148, 163, 184, 0.10)',
  warning: 'rgba(245, 158, 11, 0.10)',
  success: 'rgba(34, 197, 94, 0.10)',
  error: 'rgba(239, 68, 68, 0.10)',
};

// สถานะของตัวรายการเบิกเอง (Expenses.status — ขั้นตอนอนุมัติเบิกเงินทั่วไป ก่อนจะมาถึงคิวอนุมัติจ่ายเงิน
// ของหน้านี้) — label/สี ยึดตาม STATUS_LABEL/checkColor ใน components/Table/ExpensesTableApplove.js
// (โค้ดคนละไฟล์ ไม่ได้ share component ตามธรรมเนียมเดิมของโปรเจกต์ที่แยก constant ต่อโมดูล)
export const EXPENSE_STATUS_META = {
  PENDING: { label: 'รออนุมัติเบิก', color: 'default' },
  HOLD: { label: 'พักการเบิก', color: 'warning' },
  PREAPPROVE: { label: 'ตรวจเบื้องต้นแล้ว', color: 'secondary' },
  APPROVE_1: { label: 'อนุมัติขั้น 1', color: 'secondary' },
  APPROVE_2: { label: 'อนุมัติขั้น 2', color: 'primary' },
  APPROVE: { label: 'อนุมัติเบิกแล้ว', color: 'warning' },
  PREPARE: { label: 'เตรียมจ่าย', color: 'info' },
  SUCCESS: { label: 'จ่ายสำเร็จ', color: 'success' },
  REJECT: { label: 'ไม่อนุมัติเบิก', color: 'error' },
  CANCEL: { label: 'ยกเลิกรายการ', color: 'default' },
  LABOR_DRAFT: { label: 'รอบันทึกเงินเดือน', color: 'secondary' },
};

// สถานะการตรวจสอบรายการเบิก (Expenses.review_status) — flag อิสระ ไม่ผูกกับ payment_approval_status
// หรือ status เลย
export const EXPENSE_REVIEW_STATUS_META = {
  PENDING: { label: 'รอตรวจสอบ', color: 'default' },
  HOLD: { label: 'พักตรวจสอบ', color: 'warning' },
  REVIEWED: { label: 'ผ่านตรวจสอบ', color: 'success' },
  FLAGGED: { label: 'พบปัญหา', color: 'error' },
};
